import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

const envRaw = import.meta.env.VITE_VERCEL_ENV ?? import.meta.env.MODE;
const environment = typeof envRaw === "string" ? envRaw : "development";

/**
 * Initialize Sentry for the admin SPA. Safe to call once at app startup.
 * No-ops in development and when VITE_SENTRY_DSN is not set.
 */
export function initSentry(): void {
  if (!dsn) return;
  if (environment === "development") return;

  Sentry.init({
    dsn,
    environment,
    release: import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA,
    tracesSampleRate: environment === "production" ? 0.2 : 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

export { Sentry };
